import { persistMarketPreference } from '../utils/market-preference';

export default class CountrySelector extends HTMLElement {
  private form: HTMLFormElement | null = null;
  private countrySelect: HTMLSelectElement | null = null;
  private languageInput: HTMLInputElement | null = null;

  private onCountryChangeBound = this.onCountryChange.bind(this);

  connectedCallback(): void {
    this.form = this.querySelector('form');
    this.countrySelect = this.querySelector('select[name="country_code"]');
    this.languageInput = this.querySelector('input[name="language_code"]');

    this.addEventListeners();
  }

  addEventListeners(): void {
    this.countrySelect?.addEventListener('change', this.onCountryChangeBound);
  }

  removeEventListeners(): void {
    this.countrySelect?.removeEventListener('change', this.onCountryChangeBound);
  }

  private onCountryChange(): void {
    persistMarketPreference(this.countrySelect?.value, this.languageInput?.value);
    this.form?.requestSubmit();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('country-selector', CountrySelector);
